module.exports = __webpack_public_path__ + "static/media/V-img5.2cbb7a31.png";